import request from "./request";
import { IRequest } from "@/shared/types/request";
import { IPlatform } from "@/shared/types/platform";

export const getPlatforms = () =>
  request.get<never, IRequest<IPlatform[]>>("/platforms");
